import { checkAuthError, handleAuthError } from '../utils/authErrorHandler';
import { peopleBandCoverageError } from '../utils/peoplePriceBands';

export default function registerUpdateProductForm() {
  // UPDATE PRODUCT
  window.Alpine.store('UpdateProductForm', {
    productId: null,
    calendarId: null,
    selectedProductType: null,
    showAddRateModal: false,
    isCreatingRates: false,

    // Toggle the visibility of the add rate modal
    toggleAddRateModal() {
      console.log('toggleAddRateModal clicked!!');
      this.showAddRateModal = !this.showAddRateModal;
      console.log('showAddRateModal:', this.showAddRateModal);
    },
    setProductType(type) {
      this.selectedProductType = type;
    },
    openNewRateForm(productId, calendarId, productType) {
      this.productId = productId;
      this.calendarId = calendarId;
      this.selectedProductType = productType;
      this.toggleAddRateModal();

      // Directly set hx-post without using $nextTick
      const postUrl = `/products/add_rate_set_option/${this.calendarId}/${this.selectedProductType}/${this.productId}`;
      document.querySelector('#newRateForm').setAttribute('hx-post', postUrl);
    },
    submitRateForm(form) {
      const calendarId = form.dataset.calendarId;
      const productType = this.selectedProductType;
      const url = `/products/add_rate_set_option/${calendarId}/${productType}/${this.productId}`;

      // Get the form data
      const formData = new FormData(form);

      // Check product type-specific required fields
      if (productType === 'Accommodation') {
        const accommodationType = formData.get('accommodation_type');
        if (!accommodationType || accommodationType.trim() === '') {
          alert('Please enter a Unit Type');
          return;
        }
      } else if (productType === 'Tour') {
        const tourType = formData.get('tour_type');
        if (!tourType || tourType.trim() === '') {
          alert('Please enter a Unit Type');
          return;
        }
      }

      // Check if we have at least one complete interval
      let hasCompleteInterval = false;
      let intervalCount = 0;
      let incompleteIntervals = [];

      // Collect all interval indices from the form data
      const intervalIndices = new Set();
      for (const [key, value] of formData.entries()) {
        if (key.startsWith('intervals[') && key.includes('][')) {
          const match = key.match(/intervals\[(\d+)\]/);
          if (match && match[1]) {
            intervalIndices.add(match[1]);
          }
        }
      }

      // Check each interval for completeness
      intervalIndices.forEach((index) => {
        intervalCount++;
        const startDate = formData.get(`intervals[${index}][startDate]`);
        const endDate = formData.get(`intervals[${index}][endDate]`);

        // Check for price - either direct price or people-based prices
        let hasPrice = false;
        const price = formData.get(`intervals[${index}][price]`);

        if (price && parseFloat(price) > 0) {
          hasPrice = true;
        } else {
          // Exact group-size rows use prices[]. Range rows use bands[].
          for (const [key, value] of formData.entries()) {
            const isRowPrice =
              (key.startsWith(`intervals[${index}][prices]`) ||
                key.startsWith(`intervals[${index}][bands]`)) &&
              key.includes('[price]');
            if (isRowPrice && value && parseFloat(value) > 0) {
              hasPrice = true;
              break;
            }
          }
        }

        // Check if this interval is complete
        // For Tours, we only require startDate (no endDate needed)
        let isComplete;
        if (productType === 'Tour') {
          isComplete = startDate && hasPrice;
        } else {
          isComplete = startDate && endDate && hasPrice;
        }

        if (isComplete) {
          hasCompleteInterval = true;
        } else {
          const missingDateMessage =
            productType === 'Tour' ? !startDate : !startDate || !endDate;

          incompleteIntervals.push({
            index: parseInt(index) + 1,
            missingDate: missingDateMessage,
            missingPrice: !hasPrice,
          });
        }
      });

      // If no intervals or no complete intervals, show error
      if (intervalCount === 0) {
        alert('Please add at least one interval with dates and price.');
        return;
      }

      // If we have any incomplete intervals, show error and prevent submission
      if (incompleteIntervals.length > 0) {
        let errorMessage = 'Please complete all intervals before submitting:\n';
        incompleteIntervals.forEach((interval) => {
          errorMessage += `\n- Interval ${interval.index}: `;
          if (interval.missingDate) {
            if (productType === 'Tour') {
              errorMessage += 'Missing start date. ';
            } else {
              errorMessage += 'Missing date range. ';
            }
          }
          if (interval.missingPrice) errorMessage += 'Missing price. ';
        });
        alert(errorMessage);
        return;
      }

      const bandError = peopleBandCoverageError(formData);
      if (bandError) {
        alert(bandError);
        return;
      }

      this.isCreatingRates = true;
      console.log('Starting submission');

      fetch(url, {
        method: 'POST',
        body: formData,
        headers: {
          'X-CSRFToken': document.querySelector('[name=csrfmiddlewaretoken]')
            .value,
        },
      })
        .then(async (response) => {
          const body = await response.text();
          let data = null;
          try {
            data = JSON.parse(body);
          } catch (parseError) {
            data = null;
          }
          if (!response.ok) {
            const message =
              data && data.error
                ? data.error
                : `HTTP error! Status: ${response.status}`;
            throw new Error(message);
          }
          return data || {};
        })
        .then((data) => {
          if (data.error) {
            throw new Error(data.error);
          }
          if (data.success) {
            // Simply reload the page after successful creation
            window.location.reload();
          } else {
            throw new Error(data.message || 'Failed to create rate set');
          }
        })
        .catch((error) => {
          console.error('Error:', error);
          alert(
            error.message ||
              'An error occurred while submitting the form. Please try again.',
          );
          this.isCreatingRates = false;
        });
    },
  });
}
